import { TokenDecoder } from '../../../../../core/application/protocols/token-decoder';
import { TokenModel } from '../../domain/models/token-model';

export interface DecodeUserToken {
  decode: (token: string) => TokenModel;
}

export class LocalDecodeUserToken implements DecodeUserToken {
  constructor(private readonly tokenDecoder: TokenDecoder) {}

  decode(token: string): LocalDecodeUserToken.Response {
    if (!token) {
      throw new Error('Token not provided.');
    }
    const { email } = this.tokenDecoder.decode<{
      exp: number;
      id: string;
      email: string;
    }>(token);

    return {
      accessToken: token,
      email
    };
  }
}

export namespace LocalDecodeUserToken {
  export type Params = { token: string };

  export type Response = TokenModel;
}
